exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header {\n  width: 100%;\n  height: 50px;\n  background: #d46a6a; }\n\n.header-text {\n  font-size: 20px;\n  text-align: center;\n  margin-top: 0px;\n  padding-top: 5px;\n  color: white;\n  padding-top: 12px; }\n", "", {"version":3,"sources":["/usr/src/app/src/routes/administrator/components/administrator/Administrator.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB,EAAE;;AAExB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB,EAAE","file":"Administrator.scss","sourcesContent":["header {\n  width: 100%;\n  height: 50px;\n  background: #d46a6a; }\n\n.header-text {\n  font-size: 20px;\n  text-align: center;\n  margin-top: 0px;\n  padding-top: 5px;\n  color: white;\n  padding-top: 12px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./routes/administrator/components/administrator/Administrator.scss
// module id = 1898
// module chunks = 0